import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import dayjs from "dayjs";

import salesDood2 from "../../utils/salesDood2.png";

import axios from "axios";



// Font.register({
//   family: "Manrope",
//   fonts: [
//     {
//       src: "/fonts/Manrope/Manrope-Regular.ttf",
//       fontWeight: "normal",
//     },
//     {
//       src: "/fonts/Manrope/Manrope-Medium.ttf",
//       fontWeight: 500,
//     },
//     {
//       src: "/fonts/Manrope/Manrope-Bold.ttf",
//       fontWeight: "bold",
//     },
//   ],
// });

Font.register({
  family: "Manrope",
  src: "/fonts/Manrope/Manrope-Regular.ttf",
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Manrope",
  },
  // reserved blank space at the very top for letterhead
  headerSpace: {
    height: 80, // adjust height of reserved space
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    marginBottom: 10,
  },
  headerRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 18,
    marginBottom: 18,
  },
  smallText: {
    fontSize: 9,
    color: "grey",
  },
  customerDetails: {
    marginTop: 8,
  },
  customerName: {
    fontSize: 11,
    fontWeight: "bold",
  },
  accountDetails: {
    textAlign: "center",
  },
  logo: {
    width: 70,
    height: 20,
    marginBottom: 8,
  },
  boldText: {
    // fontSize: 14,
    fontWeight: "bold",
    // marginBottom: 4,
    // textAlign: "center",
  },
  mainTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 4,
    textAlign: "center",
  },
  currencyDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "items-center",
    textAlign: "center",
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 2,
  },
  summaryBox: {
    paddingBottom: 8,
    borderBottom: "1px solid #ccc",
  },
  transactionRow: {
    flexDirection: "row",
    borderBottom: "1px solid #eee",
    // paddingVertical: 6,
  },
  tid: {
    fontSize: 9,
    fontWeight: "bold",
  },
  ref: {
    fontSize: 9,
    color: "grey",
  },
  cell: {
    fontSize: 10,
  },
  cellCredit: {
    color: "green",
    fontWeight: "bold",
  },
  cellDebit: {
    color: "red",
    fontWeight: "bold",
  },
  footerRow: {
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40,
    flexDirection: "row",
    justifyContent: "space-between",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
    paddingTop: 6,
  },
  footer: {
    fontSize: 9,
    color: "grey",
  },
  pageNumber: {
    fontSize: 9,
    color: "grey",
  },
});

const columnWidths = {
  BANK: 1.2,
  CHQDATE: 1.5,
  CHQNO: 1.2,
  CNAME: 2,
  DEPTNO: 1,
  JVTYPE: 1,
  PDC_ACC: 1.3,
  TR_SLNO: 1,
  TYPE_NO: 1,
  AMOUNT: 1,
};

const PDCIssuedDocument = ({
  voucherAccountData,
  voucherNoFromAPI,
  voucherTypeFromAPI,
  voucherDateFromAPI,
  pdcIssuedPrintDataFromAPI,
}) => {
  console.log("pdcIssuedPrintDataFromAPI:", pdcIssuedPrintDataFromAPI);
  console.log("🚀 ~ VoucherDocument ~ voucherDateFromAPI:", voucherDateFromAPI);
  console.log("voucherAccountData from documnet::", voucherAccountData);

  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  //     const totalAmount = voucherAccountData?.reduce(
  //   (sum, t) => sum + (parseFloat(t.amount) || 0),
  //   0
  // );

  const debitTotal = voucherAccountData
    ?.filter((t) => t.accountype === "D" || t.type === "D")
    ?.reduce((sum, t) => sum + (parseFloat(t.amount) || 0), 0);

  const creditTotal = voucherAccountData
    ?.filter((t) => t.accountype === "C" || t.type === "C")
    ?.reduce((sum, t) => sum + (parseFloat(t.amount) || 0), 0);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Reserved header space for letterhead */}
        <View style={styles.headerSpace} fixed>
          {apiPaths_from_local_storage[0].REP_HEADER.includes("data:image/") ? (
            <Image
              src={apiPaths_from_local_storage[0].REP_HEADER}
              style={styles.header_image}
            />
          ) : null}
        </View>

        {/* Header (below letterhead space) */}
        <Text style={styles.mainTitle}>PDC Issued</Text>
        {/* <View style={styles.headerRow}>
          <Text style={styles.sectionTitle}>
            Voucher Type: {voucherTypeFromAPI}
          </Text>
          <Text style={styles.sectionTitle}>
            Voucher No: {voucherNoFromAPI}
          </Text>
          <Text style={styles.sectionTitle}>
            Voucher Date: {voucherDateFromAPI}
          </Text>
        </View> */}

        {/* Transactions Header */}
        <View style={styles.headerRow}>
          <Text style={[styles.boldText, { flex: columnWidths.BANK }]}>
            BANK
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.CHQDATE }]}>
            CHQ DATE
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.CHQNO }]}>
            CHQ NO
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.CNAME }]}>
            C NAME
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.DEPTNO }]}>
            DEPT NO
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.JVTYPE }]}>
            JV TYPE
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.PDC_ACC }]}>
            PDC ACC
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.TR_SLNO }]}>
            TR SLNO
          </Text>
          <Text style={[styles.boldText, { flex: columnWidths.TYPE_NO }]}>
            TYPE NO
          </Text>
          <Text
            style={[
              styles.boldText,
              { flex: columnWidths.AMOUNT, textAlign: "right" },
            ]}
          >
            AMOUNT
          </Text>
        </View>

        {/* Table Body */}
        {pdcIssuedPrintDataFromAPI?.map((t, i) => (
          <View key={i} style={styles.transactionRow}>
            <Text style={[styles.cell, { flex: columnWidths.BANK }]}>
              {t.BANK || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.CHQDATE }]}>
              {t.CHQDATE.split("T")[0] || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.CHQNO }]}>
              {t.CHQNO || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.CNAME }]}>
              {t.CNAME || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.DEPTNO }]}>
              {t.DEPTNO || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.JVTYPE }]}>
              {t.JVTYPE || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.PDC_ACC }]}>
              {t.PDC_ACC || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.TR_SLNO }]}>
              {t.TR_SLNO || "-"}
            </Text>
            <Text style={[styles.cell, { flex: columnWidths.TYPE_NO }]}>
              {t.TYPE_NO || "-"}
            </Text>
            <Text
              style={[
                styles.cell,
                { flex: columnWidths.AMOUNT, textAlign: "right" },
              ]}
            >
              {t.AMOUNT ? Number(t.AMOUNT).toFixed(2) : "-"}
            </Text>
          </View>
        ))}

        {/* Footer */}
        <View style={styles.footerRow}>
          <Text
            style={styles.pageNumber}
            render={({ pageNumber }) => `Page ${pageNumber}`}
            fixed
          />
        </View>
      </Page>
    </Document>
  );
};

export default PDCIssuedDocument;
